import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { plainToClassFromExist } from 'class-transformer';
import { z } from 'zod';
import { InstantiatedDtoError, ValidationError } from '../errors';
import { isSchemaClass } from '../types';
var VALIDATE_USED = Symbol();

function optional(schema) {
  return schema.optional().nullable().transform(function (v) {
    return v !== null && v !== void 0 ? v : undefined;
  });
}

function defaults(schema, def) {
  return schema.optional().nullable().transform(function (v) {
    return v !== null && v !== void 0 ? v : def;
  });
}

function id() {
  return z.union([z.string(), z.number()]).transform(function (v) {
    return String(v);
  });
}

function ClassFrom(schema) {
  var _a;

  return _a = function ASchemaClass() {
    _classCallCheck(this, ASchemaClass);

    if (arguments.length !== 1 || (arguments.length <= 0 ? undefined : arguments[0]) !== VALIDATE_USED) {
      throw new InstantiatedDtoError();
    }
  }, _a.__schema__ = schema, _a;
}

function validate(input, SchemaClass) {
  if (!isSchemaClass(SchemaClass)) {
    throw new ValidationError("Class \"".concat(SchemaClass.name, "\" used to validate the input data is not a valid SchemaClass"));
  }

  var result = SchemaClass.__schema__.safeParse(input);

  if (!result.success) {
    throw new ValidationError(result.error);
  }

  var base = new SchemaClass(VALIDATE_USED);
  return plainToClassFromExist(base, result.data);
}

export var ze = {
  optional: optional,
  defaults: defaults,
  id: id,
  ClassFrom: ClassFrom,
  validate: validate
};